// extracted by mini-css-extract-plugin
export var chip = "_qm-0";
export var icon = "_qm-1";
export var remove = "_qm-2";
export var removeIcon = "_qm-3";